import { render, staticRenderFns } from "./releaseGuaranteeSetting.vue?vue&type=template&id=644afa96&scoped=true&"
import script from "./releaseGuaranteeSetting.vue?vue&type=script&lang=js&"
export * from "./releaseGuaranteeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644afa96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644afa96')) {
      api.createRecord('644afa96', component.options)
    } else {
      api.reload('644afa96', component.options)
    }
    module.hot.accept("./releaseGuaranteeSetting.vue?vue&type=template&id=644afa96&scoped=true&", function () {
      api.rerender('644afa96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/SingleRule/releaseGuaranteeSetting.vue"
export default component.exports